import DailyEntries from "./DailyEntries";

export default DailyEntries;